// extracted by mini-css-extract-plugin
export default {"root":"HeaderWrapper_root__7rbQ5","draggableHeader":"HeaderWrapper_draggableHeader__5cbsI"};